import FeatureGate from "@/src/components/feature-gate";
import LatestNewsScreen from "@/src/screens/news/latest-news-screen/latest-news-screen";

export default function LatestNews() {
  return (
    <FeatureGate feature="news">
      <LatestNewsScreen />
    </FeatureGate>
  );
}